import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Install from "@/pages/Install";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Passports from "@/pages/Passports";
import Transfers from "@/pages/Transfers";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import Verify from "@/pages/Verify";
import TransferAccept from "@/pages/TransferAccept";
import PaymentReturn from "@/pages/PaymentReturn";
import { setMerchantId } from "@/lib/api";

// Capture merchant_id from Shopline OAuth redirect (?merchant_id=)
const params = new URLSearchParams(window.location.search);
const oauthMerchant = params.get("merchant_id");
if (oauthMerchant) setMerchantId(oauthMerchant);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/install" replace />} />
        <Route path="/install" element={<Install />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/passports" element={<Passports />} />
        <Route path="/transfers" element={<Transfers />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/payment/return" element={<PaymentReturn />} />
        <Route path="/verify/:certificateId" element={<Verify />} />
        <Route path="/transfer/accept/:token" element={<TransferAccept />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
